import { EllipsisVertical } from "lucide-react";
import React from "react";

import { IgIconButton } from "@intelligems/ig-theme/IgIconButton";
import { Menu } from "@mui/material";
import Grid from "@mui/material/Grid";
import type { SxProps, Theme } from "@mui/material/styles";

import { useExecutionPanelContext } from "../ExecutionPanelContext";
import { ExecutionPanelMenuItems } from "./ExecutionPanelMenuItems";

interface ExecutionPanelMenuProps {
  /** Glyph size of the ⋮ trigger. Defaults to the panel header's 18px. */
  iconSize?: number;
  /** Sizes the ⋮ trigger, for a header whose controls share one box size. */
  buttonSx?: SxProps<Theme>;
}

export const ExecutionPanelMenu = ({
  iconSize = 18,
  buttonSx,
}: ExecutionPanelMenuProps = {}) => {
  const { getSlot, menuAnchorEl, openMenu, closeMenu } =
    useExecutionPanelContext();

  return (
    <Grid>
      <IgIconButton
        onClick={(e) => openMenu(e.currentTarget)}
        aria-label="More options"
        sx={buttonSx}
      >
        <EllipsisVertical size={iconSize} />
      </IgIconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {/* Overriding this slot replaces the built-ins, like every other slot;
            render `ExecutionPanelMenuItems` to keep them. */}
        {getSlot("menuItems", <ExecutionPanelMenuItems />)}
      </Menu>
    </Grid>
  );
};
